/**
 * Canonical network definitions for the Transfer Fees table.
 * `exchangeCodes` maps exchange name (lowercase) → the network code used by that exchange.
 * Mandatory columns appear first; extras from exchange data are appended at the end.
 */
const CANONICAL_NETWORKS = [
  {
    id:       'ERC20',
    label:    'ERC20',
    fullName: 'Ethereum (ERC20)',
    exchangeCodes: { binance: 'ETH', mexc: 'ERC20', lbank: 'ERC20', bitmart: 'ERC20', bitget: 'ERC20', coinbase: 'ethereum', bingx: 'ETH', coinex: 'ETH', htx: 'usdt' }
  },
  {
    id:       'TRC20',
    label:    'TRC20',
    fullName: 'Tron (TRC20)',
    exchangeCodes: { binance: 'TRX', mexc: 'TRC20', lbank: 'TRC20', bitmart: 'TRC20', bitget: 'TRC20', coinbase: 'tron', bingx: 'TRC20', coinex: 'TRC20', htx: 'trc20usdt' }
  },
  {
    id:       'ARB',
    label:    'ARB',
    fullName: 'Arbitrum One',
    exchangeCodes: { binance: 'ARBITRUM', mexc: 'ARBITRUM', lbank: 'Arbitrum', bitmart: 'ARBITRUM', bitget: 'ARBITRUM', coinbase: 'arbitrum', bingx: 'ARBITRUM', coinex: 'ARBONE', htx: 'arbusdt' }
  },
  {
    id:       'OP',
    label:    'OP',
    fullName: 'Optimism',
    exchangeCodes: { binance: 'OPTIMISM', mexc: 'OPTIMISM', lbank: 'Optimism', bitmart: 'OPTIMISM', bitget: 'OPTIMISM', coinbase: 'optimism', bingx: 'OPTIMISM', coinex: 'OP', htx: 'optusdt' }
  },
  {
    id:       'SOL',
    label:    'SOL',
    fullName: 'Solana',
    exchangeCodes: { binance: 'SOL', mexc: 'SOL', lbank: 'SOL', bitmart: 'SOL', bitget: 'SOL', coinbase: 'solana', bingx: 'SOL', coinex: 'SOL', htx: 'solusdt' }
  },
  {
    id:       'MATIC',
    label:    'MATIC',
    fullName: 'Polygon (MATIC)',
    exchangeCodes: { binance: 'MATIC', mexc: 'MATIC', lbank: 'Polygon', bitmart: 'MATIC', bitget: 'MATIC', coinbase: 'matic', bingx: 'MATIC', coinex: 'MATIC', htx: 'maticusdt' }
  }
];

/**
 * Transfer fee endpoint config per exchange.
 * exchangeKey must match keys used in exchangeCodes above.
 */
const TRANSFER_FEE_EXCHANGES = [
  {
    exchangeId:  3,
    exchangeKey: 'binance',
    name:        'Binance',
    endpoint:    '/api/binance-transfer-fee/:userId'
  },
  {
    exchangeId:  4,
    exchangeKey: 'mexc',
    name:        'MEXC',
    endpoint:    '/api/mexc-transfer-fee/:userId'
  },
  {
    exchangeId:  5,
    exchangeKey: 'lbank',
    name:        'LBank',
    endpoint:    '/api/lbank-transfer-fee/:userId'
  },
  {
    exchangeId:  6,
    exchangeKey: 'bitmart',
    name:        'Bitmart',
    endpoint:    '/api/bitmart-transfer-fee/:userId'
  },
  {
    exchangeId:  7,
    exchangeKey: 'bitget',
    name:        'Bitget',
    endpoint:    '/api/bitget-transfer-fee/:userId'
  },
  {
    exchangeId:  8,
    exchangeKey: 'coinbase',
    name:        'Coinbase',
    endpoint:    '/api/coinbase-transfer-fee/:userId'
  },
  {
    exchangeId:  9,
    exchangeKey: 'bingx',
    name:        'BingX',
    endpoint:    '/api/bingx-transfer-fee/:userId'
  },
  {
    exchangeId:  10,
    exchangeKey: 'coinex',
    name:        'CoinEx',
    endpoint:    '/api/coinex-transfer-fee/:userId'
  },
  {
    exchangeId:  11,
    exchangeKey: 'htx',
    name:        'HTX',
    endpoint:    '/api/htx-transfer-fee/:userId'
  }
  // Add more exchanges here as they are implemented
];

export { CANONICAL_NETWORKS, TRANSFER_FEE_EXCHANGES };
